import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { CMClub, CMClubResponse, CMSite, CMSiteListResponse } from '../../../models/cm-club-service.model';
import { UserDD } from '../../../models/generic-response.model';
import { Membership, MembershipItem, MembershipListRequest, MembershipResponse, REF_MemAccountStatus, REF_SubscriptionStatus } from '../../../models/membership.model';
import { CMClubService } from '../../../services/cm-club.service';
import { MembershipService } from '../../../services/membership.service';
import { NotificationService } from '../../../services/notification.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { SessionService } from '../../../services/shared/session.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';
import { UserService } from '../../../services/user.service';

@Component({
    selector: 'app-membership-list',
    templateUrl: './membership-list.component.html',
    styleUrls: ['./membership-list.component.css']
})
/** membership-list component*/
export class MembershipListComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    dataSource: MatTableDataSource<MembershipItem>;
    displayedColumns: string[] = ['membershipID', 'membershipAccountName', 'membershipCompany', 'accountStatus', 'subscriptionType', 'membershipStartDate', 'salesClosedDate', 'currentARDate', 'dtOnboarded', 'Last12MonthsReservations'];
    encryptedUser: string;
    memberships: MembershipItem[];;
    membershipListRequest = {} as MembershipListRequest;
    user: BCMCLPUser;
    clpCompanyId: number;
    siteId: number;
    sites: number[];
    cmSites: CMSite[];
    selectedCMSiteID: number = 0;
    users: number[];
    class4Code: any;
    curTeam: TeamCodes = <TeamCodes>{};
    clubConfig: CMClub;
    clpUsersDD: UserDD[];
    selectedUserID: number = 0;
    ref_MemAccountStatus_List: REF_MemAccountStatus[];
    membershipAccountStatusID: number = 0;
    createDateFilters = [
        {
            "value": 1,
            "name": "This Month"
        },
        {
            "value": 2,
            "name": "Last Month"
        },
        {
            "value": 3,
            "name": "Custom"
        }
    ]
    customFilter: boolean = false;
    customDateStr: string = '';
    selectedCtDtFilterName: string;
    selectedCtDtFilter: number = 1;
    currentRange = new FormGroup({
        start: new FormControl<Date | null>(null),
        end: new FormControl<Date | null>(null),
    });
    selectedCustomdtStart: string;
    selectedCustomdtEnd: string;
    teamSub: Subscription;
    minDate = new Date(1753, 0, 1);   // Jan = 0
    maxDate = new Date(9999, 11, 31); // Dec = 11
    private destroy$ = new Subject<void>();
    /** membership-list ctor */
    constructor(private localService: LocalService,
        private userService: UserService,
        private _utilityService: UtilityService,
        private clubService: CMClubService,
        private _membershipService: MembershipService,
        private _notifyService: NotificationService,
        private _globalService: GlobalService,
        private _router: Router,
        private route: ActivatedRoute,
        private datePipe: DatePipe,
        private _teamOfficeService: TeamOfficeService,
        private _sessionService: SessionService
    ) {
        this.localService.setShowMenu(true);
        this.localService.setIsMembership(true);
        this.localService.setRouteName("mem-membership-list");
        this.localService.updateTeamDD(true)

    }


    //ngAfterViewInit() {
    //    this.sites = [];
    //    this.encryptedUser = localStorage.getItem("token");
    //    this.siteId = this.route.snapshot.queryParams.siteId;
    //    this.sites.push(47);
    //    this.class4Code = this.route.snapshot.queryParams.c4Code;
    //    if (this.encryptedUser) {
    //        this.encryptedUser = this.encryptedUser + ":" + (this.isAI ? "1" : "0")
    //        this.authenticateR().then(() => {
    //            if (this.user) {
    //                this.users = [];
    //                this.users.push(this.user.cLPUserID);
    //                this.users.push(206);
    //                this.loadData();
    //            }
    //            else {
    //                this._router.navigate(['/unauthorized']);
    //            }
    //        });
    //    }
    //    else {
    //        this._router.navigate(['/unauthorized']);
    //    }
    //}

    async ngOnInit() {
        this.localService.setShowMenu(true);
        this.localService.setIsContract(false);
        this.localService.setIsMembership(true);
        this.localService.setRouteName("mem-membership-list");

        //const queryParams = this.route.snapshot.queryParams;
        this.encryptedUser = await this._sessionService.getSession();
        //let currUserToken = localStorage.getItem("token") ? localStorage.getItem("token") : null;
        this.sites = [];
        this.siteId = this.route.snapshot.queryParams.siteId;
        if (this.siteId > 0)
            this.sites.push(this.siteId);
        this.class4Code = this.route.snapshot.queryParams.c4Code;
        //if (currUserToken == null) {
        //    this.encryptedUser = queryParams['r'];
        //} else {
        //    this.encryptedUser = currUserToken;
        //}
        if (this.encryptedUser) {
            await this.authenticateR();
            if (this.user) {
                localStorage.setItem("token", this.encryptedUser)
                this.users = [];
                this.loadData();
                //this._router.navigate(['/mem-membership-list']);
            }
            //else {
            //    this.encryptedUser = queryParams['r'];
            //    await this.authenticateR();
            //    if (this.user) {
            //        localStorage.setItem("token", this.encryptedUser);
            //        this._router.navigate(['/mem-membership-list']);
            //        this.loadData();
            //    }
            //    else {
            //        this._router.navigate(['/unauthorized']);
            //    }
            //}

        }
        else {
            this._router.navigate(['/unauthorized']);
        }

        //this.getMembershipList();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }

    private async authenticateR() {

        await this.localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    this.clpCompanyId = this.user?.cLPCompanyID

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    getDate(value) {
        if (value == '0001-01-01T00:00:00') {
            return '';
        }
        else
            return value;
    }

    async loadData() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null) {
                this.curTeam = data;
                await this.CMClub_Get();
                await this.siteSearch();
                this.ref_MemAccountStatus_List = this.localService.refMem_GetAllResponse.ref_MemAccountStatus_List;
                await this.cLPUserGetListByTeamCode(this.clpCompanyId, this.curTeam?.teamCode);
                await this.getMembershipList();
                this.users = [];
            }
            else {
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
                await this.CMClub_Get();
                await this.siteSearch();
                this.ref_MemAccountStatus_List = this.localService.refMem_GetAllResponse.ref_MemAccountStatus_List;
                await this.cLPUserGetListByTeamCode(this.clpCompanyId, this.curTeam?.teamCode);
                await this.getMembershipList();
                this.users = [];
            }
        })

    }

    selectRow(row: any): void {
        if (!row?.membershipIID) return;
        const url = `/mem-membership/${row.membershipIID}`;
        window.open(url, '_blank');
    }

    formatDate(dateString) {
        if (dateString != '' && dateString != null) {
            const date = new Date(dateString);
            //const formattedDate = `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
            const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            return formattedDate;
        }
        else return '-';
    }

    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {
            await this.clubService.CMClub_Get(this.encryptedUser, this.clpCompanyId, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig;
                    }

                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async getMembershipList() {
        const today = new Date();
        this.membershipListRequest.clubId = this.clubConfig?.clubId;
        this.membershipListRequest.sites = this.sites;
        this.membershipListRequest.users = this.users;
        this.membershipListRequest.membershipAccountStatus = this.membershipAccountStatusID;
        this.membershipListRequest.dateType = +this.selectedCtDtFilter;
        this.membershipListRequest.timeFrame = +this.selectedCtDtFilter;
        this.membershipListRequest.strdtEnd = this.selectedCustomdtEnd;
        this.membershipListRequest.strdtStart = this.selectedCustomdtStart;
        this.membershipListRequest.dtEnd = today;
        this.membershipListRequest.dtStart = today;

        await this._membershipService.membership_GetList(this.encryptedUser, this.membershipListRequest, this.user?.cLPUserID).
            then(async (result: MembershipResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.memberships = response?.memberships;
                    if (this.memberships.length > 0) {
                        console.log('this.memberships', this.memberships);
                    }
                    this.dataSource = new MatTableDataSource(this.memberships);
                    this.addTimeout(() => {
                        this.dataSource.paginator = this.paginator;
                    }, 1000)
                    this.dataSource.sort = this.sort;

                    this.dataSource.sortingDataAccessor = (item: MembershipItem, property: string): any => {
                        switch (property) {
                            case 'dtCreated':
                            case 'dtOnboarded':
                            case 'membershipStartDate':
                            case 'salesClosedDate':
                            case 'currentARDate':
                                return new Date(item[property]);
                            case 'primaryCaptainLastName':
                                return item.primaryCaptainLastName;
                            default:
                                return typeof item[property] === 'string'
                                    ? item[property].toLowerCase()
                                    : item[property];
                        }
                    };


                    //this.dataSource.filterPredicate =
                    //    (data: CMContractItem, filter: string) => {
                    //        let values = filter.split(' ');

                    //        let finalValues: boolean[] = [];
                    //        let final: boolean = true;

                    //        values.forEach((value) => {
                    //            finalValues.push(data.cmContractID.toString().indexOf(value) != -1 ||
                    //                data.contactName.trim().toLowerCase().indexOf(value) != -1 ||
                    //                this.formatDate(data.dtCreated).toLowerCase().indexOf(value) != -1 ||
                    //                this.formatDate(data.dtContractEnd).toLowerCase().indexOf(value) != -1 ||
                    //                this.formatDate(data.dtContractStart).toLowerCase().indexOf(value) != -1 ||
                    //                this.formatDate(data.dteSig).toLowerCase().indexOf(value) != -1 ||
                    //                this.formatDate(data.dtPaymentBegins).toLowerCase().indexOf(value) != -1 ||
                    //                data.fees.trim().toLowerCase().indexOf(value) != -1 ||
                    //                this.formatMems(data.Members).trim().toLowerCase().indexOf(value) != -1 ||
                    //                data.siteName.trim().toLowerCase().indexOf(value) != -1 ||
                    //                data.status.trim().toLowerCase().indexOf(value) != -1
                    //            );
                    //        });

                    //        //only return if all values are true
                    //        finalValues.forEach(f => {
                    //            if (!f)
                    //                final = false;
                    //        });

                    //        return final;
                    //    };
                }

            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-list.cMContractGetList", err.message, null,
                    'clpCompanyId: ' + this.clpCompanyId
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async cLPUserGetListByTeamCode(clpCompanyId, teamCode) {
        await this.userService.cLPUserGetListByTeamCode(this.encryptedUser, clpCompanyId, teamCode ? teamCode : this.user?.cLPUserID).
            then(async (result: UserDD[]) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.clpUsersDD = response
                    this.clpUsersDD.unshift({
                        value: 0,
                        text: "--ALL--"
                    })
                }

            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                    'clpCompanyId: ' + this.clpCompanyId
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this.clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.cmSites = response?.sites
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }


    async onChangeUserDD() {
        if (this.selectedUserID > 0) {
            this.users = [];
            this.users.push(this.selectedUserID);
            await this.getMembershipList();
        }
        else {
            this.users = [];
            await this.getMembershipList();
        }
    }

    async onChangeCMSite() {
        if (this.selectedCMSiteID > 0) {
            this.sites = [];
            this.sites.push(this.selectedCMSiteID);
            await this.getMembershipList();
        } else {
            this.sites = [];
            await this.getMembershipList();
        }
    }

    async onChangeStatus() {
        await this.getMembershipList();
    }

    async createDtFilterChange() {
        let value = this.selectedCtDtFilter;

        if (value != 3) {
            this.selectedCtDtFilter = +value;
            await this.getMembershipList();
        }
        else {
            this.customDateStr = ''
            this.customFilter = true;
        }
    }

    revertCustomFinalizeddtFilter() {
        this.customFilter = false;
        this.selectedCtDtFilter = 1;
        this.selectedCtDtFilterName = "This Month";
        this.currentRange = new FormGroup({
            start: new FormControl<Date | null>(null),
            end: new FormControl<Date | null>(null),
        });
        this.getMembershipList();
    }


    dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        var startDt = dateRangeStart.value;
        var endDt = dateRangeEnd.value;

        if (!startDt || !endDt) {
            return;
        }

        const startDateObj = new Date(startDt);
        const endDateObj = new Date(endDt);

        if (isNaN(startDateObj.getTime()) || isNaN(endDateObj.getTime()) || startDateObj > endDateObj) {
            return;
        }


        if (startDt) {
            let customdtStart = this.datePipe.transform(startDt, 'MMddyyyy');
            this.selectedCustomdtStart = customdtStart;

        }
        if (endDt) {
            let customdtEnd = this.datePipe.transform(endDt, 'MMddyyyy');
            this.selectedCustomdtEnd = customdtEnd;
            //this.selectedCtDtFilter = 3;
            this.selectedCtDtFilterName = "Custom"
            if (this.selectedCustomdtStart && this.selectedCustomdtEnd != null) {
                this.getMembershipList();
            }
        }
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim().toLowerCase();
        if (this.dataSource) {
            this.dataSource.filter = filterValue;
        }
    }

    navToMemContact(contactID) {
        let url = 'mem-contact/' + contactID;
        window.open(url, '_blank');
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

}
